<template>
  <vx-card no-shadow>

    <vs-input type="password" class="w-full mb-base" label-placeholder="旧密码" v-model="old_password" />
    <vs-input type="password" class="w-full mb-base" label-placeholder="新密码" v-model="new_password" />
    <vs-input type="password" class="w-full mb-base" label-placeholder="确认新密码" v-model="confirm_new_password" />

    <!-- Save & Reset Button -->
    <div class="">
      <vs-button class="ml-auto mt-2" @click="submitForm">修改密码</vs-button>
    </div>
  </vx-card>
</template>

<script>
export default {
  data() {
    return {
      old_password: "",
      new_password: "",
      confirm_new_password: "",
    }
  },
  methods: {
    resetForm() {
      this.old_password = ''
      this.new_password = ''
      this.confirm_new_password = ''
    },
    async submitForm() {
      if (this.new_password !== this.confirm_new_password) {
        this.$notify({
          color: 'danger',
          title: "新密码与确认密码不一致"
        })
        return
      }
      await this.$s.user.resetPassword({
        newPassword: this.new_password,
        oldPassword: this.old_password,
      }).then(() => {
        this.$notify({
          color: 'success',
          title: "密码修改成功",
          text: '请牢记您的新密码'
        })
        this.resetForm()
        
      }).catch(err => {
        this.$notify({
          color: 'danger',
          title: "密码修改失败",
          text: '失败原因：' + this.$util.codes[err.status]
        })
      })

    }
  }
}
</script>
